<img *ngIf="!type" src="assets/images/logo/logo-text.png" [ngClass]="classes" alt="Company logo">
<img *ngIf="type && type === 'dark'" src="assets/images/logo/logo-text-on-dark.png" [ngClass]="classes" alt="Company logo">
<img *ngIf="type && type === 'light'" src="assets/images/logo/logo-text.png" [ngClass]="classes" alt="Company logo">
